var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 3.25113C6.47858 3.25113 2.00259 6.88738 2.00259 11.3751C2.00259 13.2342 2.77984 14.9371 4.06873 16.308C3.48677 17.8469 2.27599 19.1514 2.25647 19.167C1.99869 19.4404 1.92838 19.8388 2.0768 20.1825C2.22522 20.5262 2.56502 20.7489 2.93997 20.7489C5.342 20.7489 7.23629 19.7451 8.37286 18.9405C9.50162 19.2959 10.7202 19.499 12.0013 19.499C17.524 19.499 22 15.8628 22 11.3751C22 6.88738 17.524 3.25113 12.0013 3.25113ZM12.0013 17.6243C10.9585 17.6243 9.92735 17.4641 8.93919 17.1517L8.05259 16.8705L7.29097 17.4095C6.73245 17.8039 5.96692 18.2453 5.04517 18.5421C5.33029 18.0695 5.60759 17.5383 5.82241 16.972L6.23642 15.8745L5.43184 15.023C4.7249 14.2692 3.87735 13.0233 3.87735 11.3751C3.87735 7.93021 7.52141 5.12589 12.0013 5.12589C16.4812 5.12589 20.1252 7.93021 20.1252 11.3751C20.1252 14.8199 16.4812 17.6243 12.0013 17.6243Z",
    fill: "#A1A4B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.eae172e8.svg";
export { ForwardRef as ReactComponent };